import React, { PropTypes } from "react";
import Rcslider from "rc-slider";
import extend from "extend";

export default class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.timeout = null;
    }

    onChange(value) {
        if (this.timeout !== null) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.props.onChange({ min: value[0], max: value[1] });
        }, 100);
    }

    render() {
        const defaultValue = this.props.value && this.props.value.min && this.props.value.max ?
            [parseInt(this.props.value.min, 10), parseInt(this.props.value.max, 10)] :
            [this.props.min, this.props.max];

        const props = extend(true, { range: true, allowCross: false }, this.props);
        delete props.value;

        return (
          <div>
            <div className="form-control">
              <Rcslider
                {...props}
                defaultValue={defaultValue}
                onChange={value => this.onChange(value)}
                tipFormatter={value => (value / 100)}
              />
            </div>
          </div>
        );
    }
}

Slider.propTypes = {
    value: PropTypes.shape({
        min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Atoms/Slider.jsx